// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6d8af941","453":"cf11b5be"}[chunkId] + ".chunk.js";
};